//@ts-nocheck
/* tslint:disable */
import { store } from '../app.component';
import { get, set, size, take, first, uniqBy } from 'lodash';
import { Equipment, _Equipment } from '../_shared/interfaces/equipment';
import moment from 'moment';
import { Publish } from '../_shared/interfaces/publish';
import { hydrateSensors, hydrateModels2 } from '../_shared/lib/hydrate';
import {
  createOrUpdateEquipment,
  getEquipments,
  deleteEquipment,
  getEquipmentRecords,
  getEquipment,
} from '../_shared/services/manage-equipment.service';
import { thresholds } from '../_shared/lib/thresholds';
import { Model, _Model } from '../_shared/interfaces/model';
import { Location } from '../_shared/interfaces/location';
import {
  createModel,
  getModels,
  updateModel,
} from '../_shared/services/manage-models.service';
import { updateLocation } from '../_shared/services/manage-locations.service';
import { sendDeviceCommand } from '../_shared/services/manage-schedule.service';
import { Org } from '../_shared/interfaces/org';
import { Emails } from '../_shared/lib/emails';
import { sendEmail } from '../_shared/services/email.service';
import getConfig, { getEnv, getUrl } from '../config';
import { OrgType } from '../_shared/interfaces/orgType';
import { updateOrgType } from '../_shared/services/manage-org-types.service';
import { getHistory } from '../_shared/services/device-history.service';
import { createPublish } from '../_shared/services/publish.service';
import { cleanPhoneNumber, removeEmpty } from '.';
import { updateOrg } from '../_shared/services/manage-orgs.service';
import { awaitAll, prog } from './awaitAll';
import { createSensor, getSensor, updateSensor } from '../_shared/services/manage-sensors.service';
import axios from 'axios';
import { instance } from '../_shared/services/instance';
import { updateParticleName } from '../dashboard/manufacture-process/manufacture-process.utils';

export const findEquipFromCoreid = (coreid: string) => {
  const sState = store.getState();
  const eqs = get(sState, 'dash.equipment', []) as Equipment[];
  // tslint:disable-next-line:no-console
  console.log(get(sState, ['dash', 'equipMap', coreid]));
  return {
    equipment: eqs.find(e => e.deviceId === coreid),
    eMap: get(sState, ['dash', 'equipMap', coreid]),
  };
};

export const findEquipWhere = async (where = {}) => {
  // tslint:disable-next-line:max-line-length
  const eqs = await getEquipments(undefined, false); // get(sState, 'dash.equipment', []) as Equipment[];

  const eqret = eqs.filter(e => {
    let match = false;
    for (let k in where) {
      match = get(e, k) === get(where, k);
    }
    return match;
  });
  // tslint:disable-next-line:no-console
  console.log(eqret);
  return eqret;
};

export const findEquipsWhere = async (where = {}) => {
  // tslint:disable-next-line:max-line-length
  const eqs = await getEquipments(undefined, false); // get(sState, 'dash.equipment', []) as Equipment[];
  const { dash } = store.getState();
  // tslint:disable-next-line:no-console
  const eqret = eqs.filter(e => {
    e = {
      ...e,
      emap: get(dash, `equipMap.${e.deviceId}`, {}),
    };

    if (typeof where === 'function') {
      try {
        return where(e);
      } catch (err) { }
    } else {
      let match = false;
      for (let k in where) {
        match = get(e, k) === get(where, k);
      }
      return match;
    }
  });
  return eqret;
};

export const findLocationsWhere = (where = {}) => {
  // tslint:disable-next-line:max-line-length
  const sState = store.getState();
  const eqs = get(sState, 'dash.locations', []) as Location[];
  // tslint:disable-next-line:no-console
  console.log(
    eqs.filter(e => {
      let match = false;
      for (let k in where) {
        match = get(e, k) === get(where, k);
      }
      return match;
    })
  );
};

export const findLocationsWithCode = () => {
  // tslint:disable-next-line:max-line-length
  const sState = store.getState();
  const eqs = get(sState, 'dash.locations', []) as Location[];
  // tslint:disable-next-line:no-console
  console.log(eqs.filter(e => e.code));
};

export const getOrgById = (id: string) => {
  const sState = store.getState();
  const eqs = get(sState, 'dash.orgs', []) as Org[];
  // tslint:disable-next-line:no-console
  console.log(eqs.filter(e => e.id === id));
};

export const findPreviousSerials = async (where = {}) => {
  // tslint:disable-next-line:max-line-length
  const eqs = await getEquipments(undefined, false); // get(sState, 'dash.equipment', []) as Equipment[];
  // tslint:disable-next-line:no-console
  console.log(
    eqs.filter(e => {
      return e.previousSerials;
    })
  );
};

export const findEquipFromSN = (coreid: string) => {
  const sState = store.getState();
  const eqs = get(sState, 'dash.equipment', []) as Equipment[];
  return eqs.find(e => e.equipmentSN === coreid);
};

export const updateEquipModel = () => {
  const sState = store.getState();

  const equip = get(sState, 'dash.equipment', []);
  const models = get(sState, 'dash.models', []);
  const me: any = get(sState, 'auth.user');

  const findOldModel = (modelId: string) => {
    // tslint:disable-next-line:no-any
    return models.find((m: any) => m.oldModel === modelId);
  };

  equip.map((e: Equipment) => {
    const modelId = get(e, 'modelId');
    if (modelId) {
      const newModel = findOldModel(modelId);
      if (newModel) {
        e.modelId = newModel.id;
        set(e, 'updatedAt', moment().toISOString());
        set(e, 'updatedBy', me.userId);
        createOrUpdateEquipment(e);
      }
    }
  });
};

export const updateModelImage = () => {
  const sState = store.getState();

  const models = get(sState, 'dash.models', []);

  models.map((m: Model) => {
    if (m.type === 'compressor') {
      m.image = 'compressor.png';
      updateModel(m);
    }
  });
};

export const cleanEquipment = () => {
  const sState = store.getState();
  const me: any = get(sState, 'auth.user');
  const equip = get(sState, 'dash.equipment', []);

  equip.map((e: Equipment) => {
    if (e.key) {
      delete e.key;
      set(e, 'updatedAt', moment().toISOString());
      set(e, 'updatedBy', me.userId);
      createOrUpdateEquipment(e);
    }
  });
};

export const updateAllEquipment = () => {
  const sState = store.getState();
  const me: any = get(sState, 'auth.user');
  const equip = get(sState, 'dash.equipment', []);

  equip.map((e: Equipment) => {
    set(e, 'updatedAt', moment().toISOString());
    set(e, 'updatedBy', me.userId);
    e.showOnDash = true;
    createOrUpdateEquipment(e);
  });
};

const setNewThresholds = () => {
  const sState = store.getState();
  const models = get(sState, 'dash.models', []);

  models.map((m: Model) => {
    const thresh = get(thresholds, m.id);
    if (thresh) {
      set(m, 'thresholds', thresh);
      updateModel(m);
    }
  });
};

export const getStore = () => {
  const sState = store.getState();
  return {
    store,
    sState,
  };
};

export const findDailys = () => {
  const sState = store.getState();
  const emap = get(sState, 'dash.equipMap');
  const found = [];
  for (let k in emap) {
    const e = emap[k];
    const sensors = get(e, 'sensorStatistics', []);
  }
};

export const findAlertData = (coreid: string) => {
  const sState = store.getState();
  const sensors = get(
    sState,
    `dash.equipMap.${coreid}.sensorStatistics`
  ) as Publish[];
  const alerts = sensors.filter(s => {
    return s.event === 'dz_alert_data';
  });
  return alerts;
};

export const setLocationDates = () => {
  const sState = store.getState();
  const locations = get(sState, 'dash.locations', []) as Location[];
  locations.map(l => {
    updateLocation({
      ...l,
      activationDate: new Date('1/1/2020').toISOString(),
    } as Location)
      .then(resp => console.warn(resp))
      .catch(err => console.error(err));
  });
};

export const findLocationCancel = () => {
  const sState = store.getState();
  const locations = get(sState, 'dash.locations', []) as Location[];
  return locations.filter(l => l.cancelDate);
};

export const updateDeviceLocationHistories = () => {
  const url =
    'https://5i0j2yyd8b.execute-api.us-east-1.amazonaws.com/dev/history/create';
  const sState = store.getState();
  const equipment = get(sState, 'dash.equipment', []) as Location[];
  equipment.map(l => {
    fetch(url, {
      method: 'POST',
      body: JSON.stringify({ ...l }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then(resp => console.warn(resp))
      .catch(err => console.error(err));
  });
};

export const createEquip = () => {
  const eqs = [
    {
      id: '12a79176-39a0-47a4-82dd-bd74d191a344',
      alert: 0,
      alwaysSmart: false,
      bars: 3,
      controllerSerial: 'P007AB1342UMNPY',
      createdAt: '2020-10-01T15:50:05.203Z',
      createdBy: 'rpierce@dentalez.com',
      deviceId: 'e00fce68dc6a55656bac0f45',
      deviceStatus: 'on',
      doPurchaseOrder: '85856-3-966 ',
      DOSaleDate: '2020-10-24T00:52:25.627Z',
      dryerSerial: '111900166',
      equipmentSN: 'ACR2010115',
      fw_version: 54,
      heads_enabled: [true, true],
      isActive: 1,
      model: 'Aeras 6 Compressor',
      modelId: 'C6-2',
      modes: {
        debug: 0,
        high_pressure: false,
        high_voltage: false,
        maintenance: false,
      },
      mSerial1: '0320329144',
      mSerial2: '0320326013',
      name: 'ACR2010115',
      onConsignment: false,
      schedule_enabled: true,
      serviceOrgId: '1efdd550-fa6a-4420-adee-281ede3e7897',
      showOnDash: true,
      SOSaleDate: '2020-11-18T16:24:38.930Z',
      subscriptionHistory: [
        {
          billingPreference: 'trial',
          subscriptionEnd: '2021-11-08T04:59:59.999Z',
          subscriptionStart: '2021-05-07T04:00:00.000Z',
        },
      ],
      tankSerial: '2250919',
      test: '2020-10-01T16:16:17.069Z',
      testCompletion: '2020-10-01T17:14:38.926Z',
      testDataUrl:
        'https://publish-test-results-dev.s3.amazonaws.com/ACR2010115/2020-10-01T17:14:42.157Z-ACR2010115.pdf',
      testStartedBy: 'Renee Pierce',
      type: 'compressor',
      updatedAt: '2022-04-16T14:24:01.176Z',
      updatedBy: 'publish@dentalez.com',
      previousSerials: [
        {
          dateChange: '2020-05-20T17:27:41.455Z',
          controllerSerial: 'P007VN952DTFYJK',
          deviceId: 'e00fce6811c0e0f01a11e152',
          replaceDate: '2020-05-20T17:27:41.455Z',
        },
      ],
    },
  ];

  eqs.map(e => {
    const eq = new _Equipment((e as unknown) as Equipment);
    if (eq.serialNumber) {
      delete eq.serialNumber;
    }
    createOrUpdateEquipment(eq);
  });
};

export const createChair = async () => {
  const eq = new _Equipment({
    modelId: 'CHAIR-1',
    deviceId: 'e00fce687bba5984a68chair',
  } as Equipment);

  // tslint:disable-next-line:no-console
  console.log({ eq });

  const created = await createOrUpdateEquipment(eq);

  return created;
};

export const getChair = async () => {
  const eq = await findEquipFromCoreid('e00fce687bba5984a68chair');
  // tslint:disable-next-line:no-console
  console.log({ eq });
  return eq;
};

export const updateChair = async (obj = {}) => {
  const eq = await getChair();

  // obj = {
  //   showOnDash: true,
  //   modelId: 'CHAIR-6400',
  //   equipmentSN: 'BU22060001',
  //   fw_version: 'v12.1',
  //   hardwareVersion: 'v3',
  //   serviceOrgId: '84e15035-c067-4de5-9584-d636bd33003f',
  //   dentalOrgId: '8da147de-ac76-46e0-928f-0b86fe270a3f',
  //   locationId: '80cba88f-14a2-43a4-8c31-c75b3218ef4b',
  //   ...obj,
  // }

  const upd = new _Equipment({ ...(eq.equipment || {}), ...obj } as Equipment);
  const created = await createOrUpdateEquipment(upd);

  // tslint:disable-next-line:no-console
  console.log({ eq, created });

  return eq;
};

export const deviceCommand = async (id: string, command: string) => {
  const resp = await sendDeviceCommand(id, { arg: command });
  console.warn(resp);
};

export const updateInstallTimes = async () => {
  const devs = `e00fce6801c27c6ac5f24485,ABU1035102,2025-05-27T16:03:44.884Z
e00fce6802034d9c09b47721,ABU1035070,2024-12-12T20:40:06.529Z
e00fce680367923798bb67b7,ABU1035075,2024-12-18T18:30:35.570Z
e00fce6804ad96f294eb7f76,ABU1035139,2025-09-04T13:31:37.721Z
e00fce68087be0b1d134f00e,ABU1035092,2025-02-24T15:21:10.147Z
e00fce6810168929919b32cc,ABU1035051,2024-10-22T17:18:08.705Z
e00fce68108505377734b78d,ABU1035079,2024-12-23T14:45:23.528Z
e00fce6813e98d911f8e35f0,ABU5555555,2024-07-18T19:47:09.841Z
e00fce6815aede3d018cd39a,ABU1035065,2024-12-06T19:18:46.102Z
e00fce6819bea98a271c362e,ABU1035059,2024-12-04T19:00:27.111Z
e00fce681ed10fb155dc3b51,ABU1035133,2025-07-24T13:03:48.497Z
e00fce68209bfd0a9f256487,ABU1035068,2024-12-13T14:22:51.914Z
e00fce68263d2517a252b0cc,ABU1035071,2024-12-12T20:51:13.915Z
e00fce6826b23bc2bce1c630,ABU1035086,2025-02-05T19:25:40.968Z
e00fce68278a66eb0a972445,ABU1035125,2025-04-30T16:06:49.077Z
e00fce68299f1f92951264b6,ABU1035047,2024-10-10T20:20:02.725Z
e00fce6829a60629ccf5892c,ABU1035094,2025-02-24T21:00:24.153Z
e00fce682eaaeb643d0945b6,ABU1035026,2024-08-26T18:07:11.369Z
e00fce682f48c87533463525,ABU1035081,2024-12-30T20:38:11.266Z
e00fce682fa6179f68864d5c,ABU1035132,2025-07-23T11:40:36.139Z
e00fce6830e15846cb96ccef,ABU1035130,2025-06-19T12:01:39.477Z
e00fce683599e2be3212d9b3,ABU1035113,2025-04-15T20:43:50.514Z
e00fce683cdae9f8e7f6622d,ABU1035082,2024-12-30T21:45:53.081Z
e00fce683e696f2da7edcf21,LancasterChair,2024-06-17T20:56:45.376Z
e00fce683f8637f518abc692,ABU5555555,2024-07-18T19:47:09.841Z
e00fce68428b61cb71d4acce,ABU1035126,2025-06-02T15:03:51.533Z
e00fce6842da2cd4d0135d89,ABU0000000,2025-06-12T19:37:48.458Z
e00fce6848670948e1104f34,ABU1035136,2025-08-13T11:34:34.116Z
e00fce684a6d5c326dc60696,ABU1234567,2025-08-05T20:38:46.911Z
e00fce684ca9bc5b3b20dbd6,ABU1035091,2025-02-24T15:01:09.625Z
e00fce684e2ad3c13c37723a,ABU1035034,2024-09-04T20:26:56.705Z
e00fce684e6f33183f2754a1,ABU1035135,2025-07-24T14:51:27.233Z
e00fce6850f3204625cb4cdc,ABU1035033,2024-09-04T19:46:25.417Z
e00fce6852d440e2e14516bf,ABU1035067,2024-12-13T12:55:55.888Z
e00fce6852e9d8acfdbe74f5,ABU1035023,2024-08-22T19:46:51.506Z
e00fce68553a9d530a27d343,ABU1035108,2025-04-14T20:57:38.308Z
e00fce685b620594bc36fbbf,ABU1035037,2024-09-09T18:41:38.922Z
e00fce685c5d1e3fd778c6bb,ABU1035117,2025-04-08T21:05:25.617Z
e00fce685c6262b3cddb6b82,ABU1035012,2024-06-19T15:25:26.836Z
e00fce685c80d3a899c0db39,ABU1035046,2024-10-21T20:22:09.340Z
e00fce685c89803bc35f46ec,ABU1035099,2025-04-15T15:51:18.175Z
e00fce685dd6f0dc12bbbf02,ABU1035127,2025-06-02T15:39:07.872Z
e00fce685dde304d3685aa9e,ABU1035004,2024-02-02T15:26:24.312Z
e00fce685e2443157ce43adf,ABU1035076,2024-12-18T21:01:11.925Z
e00fce6860b25a14d37ce3c8,ABU1035089,2025-06-12T18:09:05.645Z
e00fce6863fcb8e261a5e45e,ABU1035045,2024-10-21T20:27:12.077Z
e00fce6865c9336c550e7132,ABU1035003,2024-05-10T19:19:55.189Z
e00fce6866ef366a42f4ad28,ABU1035014,2024-06-18T13:07:36.702Z
e00fce68679a461f54cf057e,ABU1035038,2024-09-09T18:51:14.455Z
e00fce686a414a85cbdf3e0e,ABU1035134,2025-07-24T14:44:27.502Z
e00fce686cde4e77b4c8f804,ABU1035100,2025-05-27T16:18:41.506Z
e00fce686ffc6410533e1b8c,ABU1035057,2024-11-12T18:28:08.926Z
e00fce6872c428cb4b3d6adf,ABU1035096,2025-02-24T21:22:58.811Z
e00fce68735daedbbc67b98e,ABU1035026,2024-08-27T18:07:58.109Z
e00fce6873c0411e50164510,ABU1035087,2025-02-05T19:34:18.620Z
e00fce6874564da9b8c63422,BU1035002,2024-08-21T19:00:44.720Z
e00fce68757c1f44d077388c,ABU0001009,2023-04-21T18:04:59.086Z
e00fce6877b58b7114aeef9e,ABU1035128,2025-06-23T12:47:22.791Z
e00fce687a30c3283d2f9596,ABU1035061,2024-12-04T19:11:33.780Z
e00fce687a4ad51be779a052,ABU1035104,2025-05-27T15:59:13.486Z
e00fce687bbb089b3f477eb1,ABU1035062,2024-12-04T19:27:38.840Z
e00fce687c539697fa01113b,ABU1035123,2025-04-30T13:59:27.245Z
e00fce687c7e38f1119a2f45,ABU1035092,2025-02-24T15:21:10.147Z
e00fce687d873999d7545d36,ABU1035099,2025-04-15T15:52:21.895Z
e00fce687e70ece1b9b7d1cc,BU0001026,2024-01-29T21:03:26.076Z
e00fce687fa240dfa5a63d6d,ABU1035054,2024-11-12T18:15:48.653Z
e00fce688254a546cc82ec61,ABU1035049,2024-10-29T12:31:38.286Z
e00fce68836bba1cdf0374e3,ABU1035022,2024-08-26T19:54:21.583Z
e00fce688581815628a061e0,ABU1035035,2024-09-04T20:20:56.415Z
e00fce6887f12d4be8b58a7a,ABU1035078,2024-12-18T20:55:34.002Z
e00fce68901f62e73d5cf5e1,ABU1035074,2024-12-18T18:23:42.197Z
e00fce6890258182e881d4de,ABU1035004,2024-05-10T19:32:22.654Z
e00fce6894946d4548288235,ABU1035039,2024-09-23T16:21:34.885Z
e00fce6896537fb4d2dc80d8,ABU1035122,2025-04-30T13:52:17.783Z
e00fce689ae61a15aaa8b597,ABU1035025,2024-08-27T14:34:13.873Z
e00fce689aea2b314f0a04f5,ABU1035044,2024-10-21T20:14:43.169Z
e00fce68a1cfd53b230d4667,ABU1035011,2024-05-09T19:31:04.765Z
e00fce68a5227e4f887d2e32,ABU1035048,2024-10-22T17:33:12.181Z
e00fce68ac9c09b3f7c333c4,ABU1035098,2025-03-26T12:08:23.768Z
e00fce68ad79405c44200b65,ABU1035036,2024-09-09T18:47:19.064Z
e00fce68af3216eb9c9b158a,ABU1035040,2024-09-30T12:48:26.808Z
e00fce68aff02314405d2554,ABU1035043,2024-10-21T19:55:50.193Z
e00fce68b126fd5cbff4d504,ABU0001023,2024-02-08T21:03:26.076Z
e00fce68b494ad3d3540abc9,ABU1035009,2024-05-13T12:37:16.489Z
e00fce68b4d328d66fc27f56,ABU1035056,2024-11-12T21:14:22.978Z
e00fce68b4f33f635383e217,ABU1035119,2025-04-24T13:28:29.671Z
e00fce68b6231fd01183f611,ABU0001005,2024-05-08T05:00:01.290Z
e00fce68ba3d6b7ee3903ece,ABU1035118,2025-04-28T20:03:21.613Z
e00fce68bbc0ec0a38f60a95,ABU1035107,2025-04-14T20:29:13.507Z
e00fce68bca62ed130bd201a,ABU1035032,2024-09-03T20:45:12.368Z
e00fce68bcb07cca831e456e,ABU1035114,2025-04-15T21:02:44.839Z
e00fce68bd13da2b800207fb,ABU1035106,2025-04-14T21:11:41.446Z
e00fce68be0acd397838d8d0,ABU1035050,2024-10-22T17:49:20.106Z
e00fce68bf9c87394a9236b9,ABU1035015,2024-07-24T14:07:32.746Z
e00fce68c2d23594c4883382,ABU1035111,2025-04-14T19:12:51.872Z
e00fce68c392234a5bb3bf1a,ABU1035069,2024-12-17T13:19:59.610Z
e00fce68c62a2f71f29ee034,ABU1035064,2024-12-04T20:51:14.525Z
e00fce68c807c6f20afadcc1,ABU1035103,2025-05-27T19:59:47.325Z
e00fce68c9c801857892926b,ABU1035110,2025-04-15T11:22:22.952Z
e00fce68cbc20a2f5132bf9d,ABU1035080,2024-12-19T18:37:33.278Z
e00fce68cc1fd43d0b4e661e,ABU1035121,2025-04-30T13:33:42.606Z
e00fce68d096624de94c4d49,ABU1035101,2025-05-27T16:08:08.923Z
e00fce68d187155fb028be9f,ABU1035109,2025-04-15T11:08:08.687Z
e00fce68d1fc678801682a17,ABU1035073,2024-12-18T19:14:50.649Z
e00fce68d2241d2ae46aebc9,ABU1035055,2024-11-12T21:07:25.790Z
e00fce68d253a72fd473b599,ABU1234567,2025-07-16T18:57:27.384Z
e00fce68d6095cb35ca0bb2c,ABU1234567,2025-07-16T19:18:04.164Z
e00fce68d7929597a0deaabc,ABU1234568,2025-08-05T21:29:44.139Z
e00fce68d7d4b9bc7e9669a4,ABU1035131,2025-07-17T17:19:25.950Z
e00fce68d7f1a42ed7c96fe5,ABU1035138,2025-09-03T18:27:16.401Z
e00fce68d90d30cd7996b859,ABU1035112,2025-03-20T20:06:27.618Z
e00fce68dc8fa9843bfc9734,ABU1035077,2024-12-18T16:51:49.440Z
e00fce68dd7ffda0fa353021,ABU1035084,2024-12-31T15:07:52.406Z
e00fce68de8f46cf9237d772,ABU1035072,2024-12-18T19:22:52.347Z
e00fce68deacf7251b881888,ABU0035004,2024-05-20T17:59:09.072Z
e00fce68e050d2776a8ec923,ABU1035041,2024-09-25T17:39:56.966Z
e00fce68e148a0762f33d2bd,ABU1035060,2024-12-05T15:27:31.621Z
e00fce68e30f4da4ce62a52c,ABU1035053,2024-11-12T18:24:19.640Z
e00fce68e4607df2d1acadb7,ABU1035063,2024-12-03T13:32:50.678Z
e00fce68e790b6a7277b582a,ABU1035018,2024-07-25T16:09:18.767Z
e00fce68ed9633415905cd41,ABU1035083,2024-12-30T21:15:49.206Z
e00fce68f2fe9299c383f9d1,ABU1035129,2025-06-23T13:16:35.240Z
e00fce68f66422e7d159b1da,ABU1035115,2025-04-15T20:29:38.492Z
e00fce68f6fb8b4c11484043,ABU1035027,2024-08-28T20:26:09.781Z
e00fce68f713092003dc7228,ABU1035024,2024-08-26T18:04:07.505Z
e00fce68f7dc0dcc232e457b,ABU1035021,2024-08-22T20:16:19.719Z
e00fce68fa31b7dbd00ae1fd,ABU1035093,2025-02-24T21:28:29.483Z
e00fce68fb343ebceeab186b,ABU1035124,2025-04-30T14:08:03.019Z`

  const failed = [
    "e00fce68087be0b1d134f00e",
    "e00fce6813e98d911f8e35f0",
    "e00fce6815aede3d018cd39a",
    "e00fce6819bea98a271c362e",
    "e00fce68209bfd0a9f256487",
    "e00fce68263d2517a252b0cc",
    "e00fce68278a66eb0a972445",
    "e00fce6829a60629ccf5892c",
    "e00fce682eaaeb643d0945b6",
    "e00fce683f8637f518abc692",
    "e00fce6842da2cd4d0135d89",
    "e00fce684a6d5c326dc60696",
    "e00fce684ca9bc5b3b20dbd6",
    "e00fce684e2ad3c13c37723a",
    "e00fce685dde304d3685aa9e",
    "e00fce6860b25a14d37ce3c8",
    "e00fce686a414a85cbdf3e0e",
    "e00fce6877b58b7114aeef9e",
    "e00fce687c7e38f1119a2f45",
    "e00fce687e70ece1b9b7d1cc",
    "e00fce688581815628a061e0",
    "e00fce6890258182e881d4de",
    "e00fce68b126fd5cbff4d504",
    "e00fce68be0acd397838d8d0",
    "e00fce68d253a72fd473b599",
    "e00fce68d6095cb35ca0bb2c",
    "e00fce68d7929597a0deaabc",
    "e00fce68dd7ffda0fa353021",
    "e00fce68e790b6a7277b582a",
    "e00fce68f7dc0dcc232e457b",
    "e00fce68fa31b7dbd00ae1fd",
  ];

  const rows = devs.split('\n');

  const errors = [] as any;
  const complete = [] as any;

  await awaitAll(rows.map(r => () => async () => {
    const [deviceid, sn, install] = r.split(',');

    if (!failed.includes(deviceid)) { return }

    const install_time = `install_time,${parseInt(`${moment(install).valueOf() / 1000}`)}`;

    await sendDeviceCommand(deviceid, { arg: install_time }).then(() => {
      complete.push(deviceid);
    }).catch(e => {
      errors.push(deviceid);
    })
  }), { queueSize: 1 });

  console.log({
    errors,
    complete,
  })
}

export const sendTemplateEmail = async () => {
  const email = Emails.event({
    ToAddresses: ['bruce@go-helios.com'],
    Body: 'Stuff',
    Subject: 'Test Email',
  });

  const resp = await sendEmail(email, {
    type: 'aeras_device_alert',
    variables: {
      devicetype: 'Vacuum',
      alertname: 'Aeras Vacuum Reminder',
      alerttype: 'Maintenance',
      alertdescription:
        // tslint:disable-next-line:max-line-length
        'Oil and oil filter are due to be replaced.  V-belt and oil drip rate should also be inspected.  Only genuine Ramvac parts are to be used for repairs and maintenance in order to comply with the warranty terms.',
      alerticon: 'calendar',
      modelname: 'Aeras 4 Dry Vacuum',
      modelnumber: 'RV4-12',
      alertdatestamp: 'Thursday, 28 October, 2021',
      equipmentserial: 'AQT1111111',
      equipmenturl: 'https://aeras.dentalez.com',
      dentalorgname: 'Test Alert Dental Org Name',
      dentallocation: 'Test Alert Dental Org Location',
    },
  });

  console.warn(resp);
};

export const fixOrgTypes = async () => {
  const { sState } = getStore();
  const orgTypes = get(sState, 'dash.orgTypes', []);
  const newOrgTypes = orgTypes.map((ot: OrgType) => {
    if (ot.id === 1) {
      ot.types = [
        {
          value: 'government',
          id: 3,
          name: 'Government',
        },
        {
          value: 'dentalSchool',
          id: 2,
          name: 'Dental School',
        },
        {
          value: 'groupDentalPractice',
          id: 4,
          name: 'Group Dental Practice',
        },
        {
          value: 'dentalPractice',
          id: 1,
          name: 'Dental Practice',
        },
        {
          value: 'dso',
          id: 5,
          name: 'DSO',
        },
      ];
    }
    return ot;
  });
  await Promise.all(newOrgTypes.map((ot: OrgType) => updateOrgType(ot)));
};

export const deleteBlankEquipment = async () => {
  const { sState } = getStore();
  const blank = get(sState, 'dash.equipment', []).filter(
    (e: { modelId: string }) => !e.modelId
  );
  // await Promise.all(blank.map((e: Equipment) => deleteEquipment(e)));
  return blank;
};

export const fixTestResults = async () => {
  const eqs = await getEquipments(undefined, false); // get(sState, 'dash.equipment', []) as Equipment[];

  await awaitAll(
    eqs.map((e: Equipment) => () => async () => {
      const isundefined =
        (get(e, 'testDataUrl', '') || '').indexOf('/undefined') > -1;

      if (!e.deviceId || (e.testDataUrl && !isundefined)) {
        return;
      }

      const testresult = first(await getHistory(e.deviceId, 'dz_testresults'));

      if (testresult) {
        await createPublish(testresult);
      }
    }),
    { queueSize: 1 }
  );

  // tslint:disable-next-line:no-console
  console.log('COMPLETE');
};

export const fixOrgPhone = async () => {
  const { sState } = getStore();
  const orgs = get(sState, 'dash.orgs', []);

  const fixedorgs: Org[] = [];
  orgs.map((org: Org) => {
    if (!!org.phone) {
      const phone = cleanPhoneNumber(org.phone);
      if (phone !== org.phone) {
        fixedorgs.push({ ...org, phone });
      }
    }
  });

  await Promise.all(
    fixedorgs.map(async org => {
      updateOrg(org);
    })
  );
};

export const findSKEQ = async () => {
  // tslint:disable-next-line:max-line-length
  const eqs = await getEquipmentRecords(undefined, true); // get(sState, 'dash.equipment', []) as Equipment[];
  const eqret = eqs.filter(e => {
    return e.sk !== e.deviceId;
  });

  return eqret;
};

export const fixHpEquipment = async () => {
  const eqs = await getEquipments(undefined, false); // get(sState, 'dash.equipment', []) as Equipment[];

  const hpeq = eqs.filter(e => e.modelId === 'E900');
};

export const createChairModel = async () => {
  const { sState } = getStore();
  // const eqs = await getEquipments(undefined, false); // get(sState, 'dash.equipment', []) as Equipment[];
  const models = get(sState, 'dash.models', []);

  const chairs = models.filter((e: Model) => e.id === '6400');

  if (!size(chairs)) {
    await createModel(
      new _Model({
        id: '6400',
        sk: '6400',
        description: 'AERAS 6400 CHAIR',
        family: 'Aeras',
        heads: 0,
        image: '3900_Chair.jpg',
        isActive: 1,
        name: 'Aeras 6400 Chair',
        thresholds: {},
        type: 'chair',
        displayName: '6400',
      })
    );
  }
};

export const fixModelSensors = async () => {
  const { sState } = getStore();
  const sensors = get(sState, 'dash.sensors', []);
  const news = [
    { name: 'Mainboard Comms', id: 'MC', description: 'Main control board' },
    {
      name: 'Cycle Count',
      id: 'cycle_count',
      description: 'Increments each time the pump is used',
      isChair: 1,
    },
    {
      name: `Today's Sessions`,
      id: 'sessions_per_day',
      description: 'Session count for this chair, per day',
      showMin: false,
      showMax: false,
      showLegend: false,
      isChair: 1,
    },
    {
      name: 'Patient In Chair',
      id: 'in_chair',
      description:
        'Indicator of whether or not there is a patient in the chair',
      isChair: 1,
    },
    {
      name: 'Line Pressure',
      id: 'LP',
      description: 'Line pressure from facility',
      suffix: 'PSI',
      isChair: 1,
    },
    {
      name: 'Line Vacuum',
      id: 'LV',
      description: 'Line vacuum from facility',
      suffix: 'inH',
      isChair: 1,
    },
    {
      name: 'Chair Base Limit',
      id: 'BASES',
      description:
        'Indicator of whether or not the chair back position sensor is tripped',
      isChair: 1,
    },
    {
      name: 'Chair Base Position',
      id: 'BASEP',
      description:
        'Indicator of whether or not the chair back position sensor is connected',
      isChair: 1,
    },
    {
      name: 'Chair Seat Limit',
      id: 'SEATS',
      description:
        'Indicator of whether or not the chair seat position sensor is tripped',
      isChair: 1,
    },
    {
      name: 'Chair Seat Position',
      id: 'SEATP',
      description:
        'Indicator of whether or not the char seat position sensor is connected',
      isChair: 1,
    },
    {
      name: 'Cantilever Arm Limit',
      id: 'CANTIS',
      description:
        'Indicator of whether or not the cantilever arm sensor is tripped',
      isChair: 1,
    },
    {
      name: 'Button Combination or Out of Range',
      id: 'BCR',
      description: 'Unknown button combination or out of range',
      isChair: 1,
    },
    {
      name: 'Signal Strength',
      id: 'bars',
      description:
        'The strength of the cellular connection for this piece of equipment',
      showMin: false,
      showMax: false,
      isChair: 1,
    },
  ];

  const all = [...sensors, ...news];

  await Promise.all(
    all.map(async s => {
      const create = {
        ...s,
        sk: s.sk || s.id,
        isChair: s.isChair || 0,
        isCompressor: s.isCompressor || 0,
        isVacuum: s.isVacuum || 0,
        isHandpiece: s.isHandpiece || 0,
        isSterilizer: s.isSterilizer || 0,
      };

      await createSensor(create);
    })
  );
};

export const fixDisplayModels = async () => {
  const { sState } = getStore();
  const models = ['C3-12SS', 'C5-12SS'];
  const validmodels = get(sState, 'dash.models', []).filter(
    (m: Model) => models.indexOf(m.id) > -1
  );

  await Promise.all(
    validmodels.map(async (m: Model) => {
      set(m, 'showOnManu', false);
      await createModel(m);
    })
  );

  console.log({
    validmodels,
  });
};

export const transferModelsToProd = async () => {
  // const qamodels = get(await axios.get(`${getUrl('qa')}/model`), 'data.models', []);
  // await Promise.all(qamodels.map(async model => {
  //   await axios.post(`${getUrl('prod')}/model/create`, {
  //     model: removeEmpty(model),
  //   })
  // }))
  // console.log({
  //   qamodels,
  // })
};

export const transferSensorsToProd = async () => {
  // const qamodels = get(await axios.get(`${getUrl('qa')}/sensor`), 'data.sensors', []);
  // await Promise.all(qamodels.map(async sensor => {
  //   await axios.post(`${getUrl('prod')}/sensor/create`, {
  //     sensor: removeEmpty(sensor),
  //   })
  // }))
  // console.log({
  //   qamodels,
  // })
};

export const fixEq = async (coreid: string, obj = {}) => {
  const eq = findEquipFromCoreid(coreid);

  if (get(eq, 'equipment')) {
    await createOrUpdateEquipment(({
      ...get(eq, 'equipment', {}),
      ...obj,
    } as unknown) as Equipment);
  }
};

export const fixValidEq = async () => {
  const eqs = await getEquipments();

  const notValid = eqs.filter(e => !e.equipmentSN);

  await awaitAll(notValid.map(eq => () => async () => {
    await createOrUpdateEquipment(eq);
  }), {
    queueSize: 10,
    onProgress: prog,
  })

  console.log({
    notValid,
  })
};

export const addModelDisplayName = async () => {
  const models = await getModels();

  console.log(`Updating ${models.length} models...`);

  await awaitAll(models.map(m => () => async () => {
    m.displayName = m.id;
    await updateModel(m);
  }), {
    queueSize: 10,
    onProgress: prog,
  });
};

export const fixChairSessionTimeSensors = async () => {
  const totalConsultTime = await getSensor('total_consultation_time');
  totalConsultTime.description = "Session time in minutes when chair is in 'consultation' position, per day";
  await updateSensor(totalConsultTime);

  const treatmentTime = await getSensor('total_treatment_time');
  treatmentTime.description = "Session time in minutes when chair is in 'treatment' position, per day";
  await updateSensor(treatmentTime);

  const turnoverTime = await getSensor('chair_turnover_time');
  turnoverTime.description = "Time in minutes between sessions, per day";
  await updateSensor(turnoverTime);

  const totalSessionTime = await getSensor('total_session_time');
  totalSessionTime.showMin = true;
  totalSessionTime.showMax = true;
  totalSessionTime.showTotal = true;
  totalSessionTime.name = "Session Time - Total";
  totalSessionTime.description = "Total session time in minutes, per day";
  totalSessionTime.showLegend = true;
  await updateSensor(totalSessionTime);
};

export const createNewEquip = async () => {
  const ev = getEnv();

  const eqs = {
    qa: `QOFT-30V,WUX953535,WUX953535,01/27/2026,e00fce683ef34dbf52bf01df,654cfd9c-07e3-4ef6-8a48-457622a951d2,598fa91d-6b2a-4745-bd2c-c48fe3df4195
VS90,VSO90-25060001,VSO90-25060001,01/27/2026,e00fce68d5185352a089a126,654cfd9c-07e3-4ef6-8a48-457622a951d2,598fa91d-6b2a-4745-bd2c-c48fe3df4195
VS90,VSO60-2506001,VSO60-2506001,01/27/2026,e00fce68343c2f6b52ccfa3b,654cfd9c-07e3-4ef6-8a48-457622a951d2,598fa91d-6b2a-4745-bd2c-c48fe3df4195
AS100,AS012-23060003,AS012-23060003,01/27/2026,e00fce68f33e23cd1bda40b0,654cfd9c-07e3-4ef6-8a48-457622a951d2,598fa91d-6b2a-4745-bd2c-c48fe3df4195
AS100,AS012-23060006,AS012-23060006,01/27/2026,e00fce687d9ebd9fd75ac566,654cfd9c-07e3-4ef6-8a48-457622a951d2,598fa91d-6b2a-4745-bd2c-c48fe3df4195
AS100,AS012-25080045,AS012-25080045,01/27/2026,e00fce6857ee559a56046af0,654cfd9c-07e3-4ef6-8a48-457622a951d2,598fa91d-6b2a-4745-bd2c-c48fe3df4195
AS100,AS012-25080047,AS012-25080047,01/27/2026,e00fce6862457d39c97ad45f,654cfd9c-07e3-4ef6-8a48-457622a951d2,598fa91d-6b2a-4745-bd2c-c48fe3df4195`,
    prod: `QOFT-30V,WUX953535,WUX953535,01/27/2026,e00fce683ef34dbf52bf01df,3f071d26-a601-4fd3-b072-1acbc9bedcd9,83ce1c3c-6a28-4044-87fa-e746ace519b8
VS90,VSO90-25060001,VSO90-25060001,01/27/2026,e00fce68d5185352a089a126,3f071d26-a601-4fd3-b072-1acbc9bedcd9,83ce1c3c-6a28-4044-87fa-e746ace519b8
VS90,VSO60-2506001,VSO60-2506001,01/27/2026,e00fce68343c2f6b52ccfa3b,3f071d26-a601-4fd3-b072-1acbc9bedcd9,83ce1c3c-6a28-4044-87fa-e746ace519b8
AS100,AS012-23060003,AS012-23060003,01/27/2026,e00fce68f33e23cd1bda40b0,3f071d26-a601-4fd3-b072-1acbc9bedcd9,83ce1c3c-6a28-4044-87fa-e746ace519b8
AS100,AS012-23060006,AS012-23060006,01/27/2026,e00fce687d9ebd9fd75ac566,3f071d26-a601-4fd3-b072-1acbc9bedcd9,83ce1c3c-6a28-4044-87fa-e746ace519b8
AS100,AS012-25080045,AS012-25080045,01/27/2026,e00fce6857ee559a56046af0,3f071d26-a601-4fd3-b072-1acbc9bedcd9,83ce1c3c-6a28-4044-87fa-e746ace519b8
AS100,AS012-25080047,AS012-25080047,01/27/2026,e00fce6862457d39c97ad45f,3f071d26-a601-4fd3-b072-1acbc9bedcd9,83ce1c3c-6a28-4044-87fa-e746ace519b8`
  }

  //@ts-ignore
  const eq = (eqs[ev] || '').split('\n');

  //@ts-ignore
  const results = await awaitAll(eq.map(e => () => async () => {
    const [modelId, equipmentSN, name, installDateStr, deviceId, dentalOrgId, locationId] = e.split(',');
    const ee = new _Equipment({
      modelId,
      equipmentSN,
      name,
      installDate: moment(installDateStr, 'MM/DD/YYYY').toISOString(),
      deviceId,
      dentalOrgId,
      locationId,
      showOnDash: true,
    })

    const [eorig, e0, e1] = await Promise.all([
      getEquipment(deviceId),
      getEquipment(`${deviceId}_0`),
      getEquipment(`${deviceId}_1`),
    ])

    const m0 = { 
      ...ee, 
      ...(e0 || {}), 
      ...(eorig || {}), 
      deviceId: `${ee.deviceId}_0`, 
      sk: `${ee.deviceId}_0`, 
      platform: 'm1'
    }
    await createOrUpdateEquipment(m0 as Equipment);

    const m1 = { 
      ...ee, 
      ...(e1 || {}), 
      ...(eorig || {}), 
      deviceId: `${ee.deviceId}_1`, 
      sk: `${ee.deviceId}_1`, 
      showOnDash: false,
      platform: 'm1'
    }
    await createOrUpdateEquipment(m1 as Equipment);

    await deleteEquipment(ee);
  }), { queueSize: 2 })

  console.log({ results })
}

// AER-1573: Add missing 6400 Chair units from Temple University (Part 1)
export const addTempleChairs = async () => {
  // equipmentSN,deviceId (deviceIds lowercased from spreadsheet)
  // Updated from TempleWebappDoc_updated.xlsx (4 corrected deviceIds for ABU1035264, ABU1035221, ABU1035195, ABU1035246)
  const chairs = `ABU1035313,e00fce6818708436d4dc293a
ABU1035290,e00fce68c35dca684d433697
ABU1035296,e00fce68a3fa01b4e2c19f42
ABU1035288,e00fce68d5f872b55eb5c7fb
ABU1035264,e00fce68d8be2f3309fa8fbd
ABU1035305,e00fce6847b6846ae5f5c7c7
ABU1035282,e00fce6868319b1fd74a36b8
ABU1035281,e00fce682b45a8bf81b3824c
ABU1035301,e00fce681625b6232fdfcee9
ABU1035222,e00fce687fa240dfa5a63d6d
ABU1035236,e00fce68ecd9139054e87054
ABU1035221,e00fce68077a603cb1e813ba
ABU1035218,e00fce68b853162a8189e013
ABU1035244,e00fce68082e2acfa8c02820
ABU1035227,e00fce6829b6dd697abb2614
ABU1035223,e00fce681e1f665fbd808021
ABU1035229,e00fce68898fe178b8774861
ABU1035234,e00fce68588eaa76f74c0dfb
ABU1035198,e00fce68d08838cf0c42d320
ABU1035190,e00fce68b8ca0134b96e391d
ABU1035159,e00fce6859a7f4ab0bb7272b
ABU1035176,e00fce681b62313741bb6974
ABU1035233,e00fce6834b1879247145820
ABU1035188,e00fce68f7d23643f71efc65
ABU1035158,e00fce68ef9a4e4513afc686
ABU1035192,e00fce68e2d6b0a72c3141b9
ABU1035149,e00fce68c601aa6adaa275d3
ABU1035163,e00fce68a08477ef9f65fd89
ABU1035179,e00fce68a2851ebc69cef95f
ABU1035171,e00fce68048f2afe8dacf417
ABU1035164,e00fce68b722a035824f5d84
ABU1035165,e00fce68d94464680b87c2fe
ABU1035153,e00fce68f8ce971069216425
ABU1035205,e00fce688d32851083823c9f
ABU1035195,e00fce68c43e22c681d4618a
ABU1035203,e00fce6888b60d063de5a46c
ABU1035194,e00fce6803343913db0dc727
ABU1035185,e00fce68c0fc1fea4f33c439
ABU1035178,e00fce68e19e05194e7db59f
ABU1035220,e00fce68cf4a0442d04bc9a0
ABU1035187,e00fce68f3530cc3c4bad8ee
ABU1035246,e00fce688b59fe8aa83f05df
ABU1035232,e00fce68955631f0b481a4f5`;

  const rows = chairs.trim().split('\n');
  const errors = [] as any;
  const complete = [] as any;

  await awaitAll(rows.map(r => () => async () => {
    const [equipmentSN, deviceId] = r.split(',');

    try {
      // Get controllerSerial from Particle API: GET /v1/devices/:deviceId
      const deviceInfo = await axios.get(
        `https://api.particle.io/v1/devices/${deviceId}`,
        { headers: { Authorization: `Bearer ${getConfig().particle_key}` } }
      );
      console.log({ deviceInfo })
      const controllerSerial = get(deviceInfo, 'data.serial_number', '');

      const eq = new _Equipment({
        modelId: '6400',
        equipmentSN,
        name: equipmentSN,
        deviceId,
        controllerSerial,
        dentalOrgId: '60002ffc-9543-4848-967c-d2bafa20d621',
        locationId: 'f760a1b8-54bf-45a7-b9a0-47a8f4341905',
        serviceOrgId: '630e8d46-713d-493c-9e9a-b850129b2505',
        installDate: moment('01/31/2026', 'MM/DD/YYYY').toISOString(),
        isActive: 1,
        isValid: true,
        showOnDash: true,
        soPurchaseOrder: 'PO825101',
      } as Equipment);

      await createOrUpdateEquipment(eq);
      complete.push(equipmentSN);
      console.log(eq);
      console.log(`Created ${equipmentSN} (${complete.length}/${rows.length})`);
    } catch (err) {
      errors.push({ equipmentSN, deviceId, err });
      console.error(`Failed ${equipmentSN}:`, err);
    }
  }), { queueSize: 2 });

  console.log({
    total: rows.length,
    complete: complete.length,
    errors,
  });
};

// AER-1623: Add remainder of missing 6400 Chair units from Temple University (Part 2).
// Source: "Temple chair SN to Suite.xlsx" on the ticket. Excluded per the sheet: rows
// marked YES (already in app), orange rows, the "No Serial Plate" row, and
// ABU1035295/ABU1035297 (both claim deviceId e00fce68f0bd13b71bba63a9 — awaiting Rob).
// Run from the console on prod: SUPPORT.addTempleChairsPart2() — dry run by default,
// writes nothing until called with { dryRun: false }. If the dry run reports SN
// conflicts that Rob confirms are safe to overwrite, pass them in overwriteSNs.
// Validated 2026-06-15 against Rob's updated sheet: 106 addable rows ->
// 99 stub updates + 4 creates + 3 overwrites (placeholders ABU0000000 / ABU0001009,
// plus BU1035002 — ABU1035177's corrected deviceId e00fce6874564da9b8c63422 is the
// same physical chair already in the app as BU1035002; confirmed safe to relabel).
// Run for real with:
//   SUPPORT.addTempleChairsPart2({ dryRun: false, overwriteSNs: ['ABU0000000', 'ABU0001009', 'BU1035002'] })
export const addTempleChairsPart2 = async ({ dryRun = true, overwriteSNs = [] } = {}) => {
  // alexaNumber,equipmentSN,suite,deviceId (deviceIds lowercased from spreadsheet)
  const chairs = `15,ABU1035157,1106,e00fce689ac8cbcaba1441f9
18,ABU1035160,1118,e00fce68d1ce39f6294c5739
19,ABU1035161,2134,e00fce6818aef73165b2bb26
20,ABU1035162,1107,e00fce6862f822886140caca
28,ABU1035170,2111,e00fce68825c41d5a71c666a
30,ABU1035172,1116,e00fce683116f818dbb52639
31,ABU1035173,2119,e00fce68ddcb70f83497c8bf
32,ABU1035174,2113,e00fce68f1d4faf841cd8ad5
33,ABU1035175,2204,e00fce681572049fb5f15ce1
35,ABU1035177,2114,e00fce6874564da9b8c63422
38,ABU1035180,2135,e00fce687d20c3ee912a80da
39,ABU1035181,2112,e00fce689aef767eb81c3cb0
40,ABU1035182,2217,e00fce680474ed6e401a82ea
41,ABU1035183,2121,e00fce68bea17e7b4a084d04
42,ABU1035184,2503,e00fce6866b9c0f8ad27ec97
44,ABU1035186,1213,e00fce681bc944dd904c07de
47,ABU1035189,2110,e00fce680c0499cf16e35881
49,ABU1035191,1111,e00fce6831043b82afeba066
51,ABU1035193,2209,e00fce688cf9bbfdf5338c14
54,ABU1035196,1113,e00fce68c7f1b3c9bdb7dbb7
55,ABU1035197,2220,e00fce6871e51c5ed656d985
57,ABU1035199,2509,e00fce68ad20bac4f10fc1f9
58,ABU1035200,2506,e00fce687927d2b6f11ce147
59,ABU1035201,1128,e00fce6863b03b29f5bb2ff9
60,ABU1035202,1212,e00fce681b9e250966a5d595
62,ABU1035204,2511,e00fce6825ee4048a1934686
64,ABU1035206,2324,e00fce6830644230ed02a8d8
65,ABU1035207,1135,e00fce68a2d0507acf1e33b5
66,ABU1035208,1216,e00fce6814a75233fca6f206
67,ABU1035209,1121,e00fce68ab6d59ba51357a4d
69,ABU1035211,2126,e00fce68ab6f26d38c2a5eb0
71,ABU1035213,2505,e00fce680f2b05237201e4ac
72,ABU1035214,2216,e00fce683e066f463dd8ef67
73,ABU1035215,2322,e00fce68c3e58968238fa393
74,ABU1035216,2323,e00fce68e64124d59ff25f33
75,ABU1035217,2212,e00fce684b77017baebaab5b
77,ABU1035219,2214,e00fce683697b9540c1f7a8a
82,ABU1035224,2510,e00fce687f854d4f53875b22
83,ABU1035225,1117,e00fce6885874d8014bc0695
84,ABU1035226,2504,e00fce6884b99ed5d32b8ea4
86,ABU1035228,1115,e00fce682fb85e678c0f27d1
88,ABU1035230,2306,e00fce680d208e38776a86f1
89,ABU1035231,2124,e00fce68019a8845a4d2c022
93,ABU1035235,2305,e00fce68909de417e4fa4159
95,ABU1035237,2512,e00fce68937421bc0f338627
96,ABU1035238,2301,e00fce68a04cee3d98aa52a1
97,ABU1035239,2211,e00fce685a29fe03e4da3f38
98,ABU1035240,2215,e00fce685c96eb8910f34af0
99,ABU1035241,2213,e00fce6882d79b8eb2967ffe
101,ABU1035243,2303,e00fce68f764163ebd56721b
103,ABU1035245,2513,e00fce68b9d03be0f672fa07
105,ABU1035247,2501,e00fce68434819ab986a8c15
106,ABU1035248,1120,e00fce6864d2445e14d459ed
107,ABU1035249,2117,e00fce68a683ac7e0adcc2d7
108,ABU1035250,2219,e00fce68757c1f44d077388c
109,ABU1035251,2115,e00fce68f4f826efa3c610e4
110,ABU1035252,1114,e00fce684abc0c33a1885517
111,ABU1035253,2302,e00fce68fca062a0a3480a3a
112,ABU1035254,2508,e00fce68a15deb5667a07d7d
113,ABU1035255,1127,e00fce68df26c7962e9388dd
114,ABU1035256,2125,e00fce68b66980ae7ed895da
115,ABU1035257,2120,e00fce68b20846710ad8494b
116,ABU1035258,2304,e00fce688a3d09287e0d87c6
117,ABU1035259,2118,e00fce68b8c89a4602079a2e
118,ABU1035260,1124,e00fce68b155e6bac792e6fc
119,ABU1035261,2218,e00fce681d1e42d1f1356b4e
121,ABU1035263,2502,e00fce68829dfd81d4197899
123,ABU1035265,1130,e00fce6842da2cd4d0135d89
124,ABU1035266,2123,e00fce687e7ea925837d7ee6
125,ABU1035267,1119,e00fce6859d69c41eb1a18d2
126,ABU1035268,2122,e00fce688611c4461599383f
127,ABU1035269,1123,e00fce68aa984dc6b98a66fa
128,ABU1035270,1122,e00fce68ab3d0d5cf9491d9c
129,ABU1035271,1125,e00fce6842069e479fe33bb0
130,ABU1035272,1126,e00fce68c771bc33f41065ef
131,ABU1035273,2320,e00fce68e4ebceb721dca27b
132,ABU1035274,1134,e00fce6817d5f90e817d13c3
133,ABU1035275,2318,e00fce68d5cb248ed09f4334
134,ABU1035276,2315,e00fce685785133652bcb49d
135,ABU1035277,1132,e00fce685857b1374112046f
136,ABU1035278,2116,e00fce68929a624a0a42b2c6
138,ABU1035280,2314,e00fce686f1b85959f1eba36
141,ABU1035283,2317,e00fce688dfdc01dfc2d095d
142,ABU1035284,1215,e00fce68c85e0232d41e9076
143,ABU1035285,2321,e00fce68851647f0fc8c54ce
144,ABU1035286,1203,e00fce688c8466c69b584e0f
145,ABU1035287,1205,e00fce6870ac8b4c7f314ccc
147,ABU1035289,1207,e00fce680b2b1c45c4d36635
149,ABU1035291,1209,e00fce6888415977e7431f74
150,ABU1035292,1210,e00fce6853b7203f33da0212
151,ABU1035293,1204,e00fce68d22c59d98637a3b6
152,ABU1035294,1208,e00fce6881fd9d08e1567734
156,ABU1035298,1211,e00fce6867c51153f4ddf542
157,ABU1035299,2316,e00fce688a9719c012f623e1
158,ABU1035300,2133,e00fce685751082b03b0c09c
160,ABU1035302,2130,e00fce6873f0aabaf7bc43b2
161,ABU1035303,2313,e00fce68658b9e145ad781bd
162,ABU1035304,1131,e00fce68b3ad60e2adc5ef1b
164,ABU1035306,2319,e00fce68560e74c7617ac7f5
165,ABU1035307,2129,e00fce68a07eecbafde62218
166,ABU1035308,2131,e00fce68f3193524772d499c
167,ABU1035309,1214,e00fce6873753348b58220e1
168,ABU1035310,2128,e00fce684af22d5319420320
169,ABU1035311,2132,e00fce68f517c2470f835759
170,ABU1035312,1136,e00fce68cbc291690c7f3921
172,ABU1035314,1133,e00fce6811356382f7483386`;

  const rows = chairs.trim().split('\n');
  const updated = [] as any;
  const created = [] as any;
  const conflicts = [] as any;
  const particleErrors = [] as any;
  const errors = [] as any;

  await awaitAll(rows.map(r => () => async () => {
    const [alexaNumberStr, equipmentSN, suite, deviceId] = r.split(',');
    const alexaNumber = parseInt(alexaNumberStr, 10);

    try {
      // Validate the deviceId against Particle and get the controllerSerial.
      // The sheet has known transcription errors, so a 404 here means a bad
      // deviceId, not a missing device — report it, never write.
      let controllerSerial = '';
      try {
        const deviceInfo = await axios.get(
          `https://api.particle.io/v1/devices/${deviceId}`,
          { headers: { Authorization: `Bearer ${getConfig().particle_key}` } }
        );
        controllerSerial = get(deviceInfo, 'data.serial_number', '');
        if (!controllerSerial) { throw new Error('no serial_number in Particle response'); }
      } catch (perr) {
        particleErrors.push({ equipmentSN, deviceId, status: get(perr, 'response.status', String(perr)) });
        return;
      }

      // Most of these deviceIds already exist as stub records (telemetry only,
      // no SN/org). If an existing record carries a DIFFERENT real SN (e.g. the
      // C12-2 compressor on ABU1035177's deviceId), skip unless explicitly allowed.
      const existing = await getEquipment(deviceId);
      const existingSN = get(existing, 'equipmentSN', '');
      if (existingSN && existingSN !== equipmentSN && !overwriteSNs.includes(existingSN)) {
        conflicts.push({ equipmentSN, deviceId, existingSN, existingModel: get(existing, 'modelId', '') });
        return;
      }

      const eq = new _Equipment({
        ...(existing || {}),
        modelId: '6400',
        eqType: 'chair',
        equipmentSN,
        alexaNumber,
        name: `${equipmentSN} - Suite ${suite}`,
        deviceId,
        sk: deviceId,
        controllerSerial,
        dentalOrgId: '60002ffc-9543-4848-967c-d2bafa20d621',
        locationId: 'f760a1b8-54bf-45a7-b9a0-47a8f4341905',
        serviceOrgId: '630e8d46-713d-493c-9e9a-b850129b2505',
        installDate: moment('01/31/2026', 'MM/DD/YYYY').toISOString(),
        isActive: 1,
        isValid: true,
        showOnDash: true,
        soPurchaseOrder: 'PO825101',
      } as Equipment);

      if (!dryRun) {
        await createOrUpdateEquipment(eq);
      }
      (existing ? updated : created).push(equipmentSN);
      console.log(`${dryRun ? '[dry run] would write' : 'Wrote'} ${equipmentSN} (${existing ? 'update' : 'create'}, ${updated.length + created.length}/${rows.length})`);
    } catch (err) {
      errors.push({ equipmentSN, deviceId, err });
      console.error(`Failed ${equipmentSN}:`, err);
    }
  }), { queueSize: 2 });

  const summary = {
    dryRun,
    total: rows.length,
    updated: updated.length,
    created,
    conflicts,
    particleErrors,
    errors,
  };
  console.log(summary);
  return summary;
};

// AER-1545: One-shot migration to backfill push notification defaults on
// existing users (Major / Equipment Left On / Equipment Not Connected = ON;
// strips stale 'push' from the legacy service group).  Idempotent — safe to
// re-run.  Hit once per env (qa, prod) after deploy.
export const migratePushNotificationDefaults = async () => {
  try {
    const resp = await instance.post('/user/migrate-push-defaults');
    console.log('Push notification defaults migration complete:', resp.data);
    return resp.data;
  } catch (err) {
    console.error('Push notification defaults migration failed:', err);
    throw err;
  }
};

// tslint:disable-next-line:no-any
(window as any).SUPPORT = {
  getEnv,
  findEquipFromCoreid,
  moment,
  getStore,
  findAlertData,
  hydrateSensors,
  hydrateModels2,
  updateEquipModel,
  setNewThresholds,
  setLocationDates,
  updateDeviceLocationHistories,
  cleanEquipment,
  createEquip,
  updateModelImage,
  updateAllEquipment,
  findEquipFromSN,
  findEquipWhere,
  findEquipsWhere,
  findLocationCancel,
  findPreviousSerials,
  deviceCommand,
  findLocationsWhere,
  findLocationsWithCode,
  getOrgById,
  sendTemplateEmail,
  fixOrgTypes,
  deleteBlankEquipment,
  fixTestResults,
  fixOrgPhone,
  findSKEQ,
  createChair,
  updateChair,
  getChair,
  fixHpEquipment,
  createChairModel,
  fixModelSensors,
  fixDisplayModels,
  transferModelsToProd,
  transferSensorsToProd,
  fixEq,
  fixValidEq,
  updateParticleName,
  addModelDisplayName,
  fixChairSessionTimeSensors,
  updateInstallTimes,
  createNewEquip,
  addTempleChairs,
  addTempleChairsPart2,
  migratePushNotificationDefaults,
};
